var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container profile-view"},[_c('div',{staticClass:"notification is-info"},[_c('h3',{staticClass:"title"},[_vm._v("Billing Portal")]),_c('p',[_vm._v("\n      This window will now close and you will be redirected to the ShareDocView app.\n    ")])])])
}]

export { render, staticRenderFns }